import { render } from "./DesignSpinner.vue?vue&type=template&id=542ee726&scoped=true"
import script from "./DesignSpinner.vue?vue&type=script&lang=js"
export * from "./DesignSpinner.vue?vue&type=script&lang=js"

import "./DesignSpinner.vue?vue&type=style&index=0&id=542ee726&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542ee726"]])

export default __exports__